import * as React from 'react'

import { ContractsVersionDocument, ContractsVersionQuery } from 'generated/resources/graphql'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

export type ContractVersion =
  ContractsVersionQuery['contracts']['contractVersionsConnection']['nodes'][0]

interface ContextProps {
  loading: boolean
  contract: ContractVersion | undefined
  startsOn: moment.Moment | undefined
  adjustedDailyMinutes: number | undefined
}

const Context = React.createContext<ContextProps>({
  loading: false,
  contract: undefined,
  startsOn: undefined,
  adjustedDailyMinutes: undefined,
})

export const ContractsVersionProvider = ({
  employeeId,
  children,
}: {
  employeeId: number
  children: React.ReactNode
}) => {
  const { data, loading } = useQuery(ContractsVersionDocument, {
    variables: { employeeId, today: moment().format('YYYY-MM-DD') },
  })

  const contract = data?.contracts.contractVersionsConnection.nodes[0]

  return (
    <Context.Provider
      value={{
        loading,
        contract,
        startsOn: contract && contract.startsOn ? moment(contract.startsOn) : undefined,
        adjustedDailyMinutes: contract?.adjustedDailyMinutes ?? undefined,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useContractsVersion = (): ContextProps => {
  const ContractsVersion = React.useContext(Context)

  if (!ContractsVersion) {
    throw new Error('useContractsVersion must be used within a ContractsVersionProvider')
  }

  return ContractsVersion
}
